import { Logo } from "./Logo";
import { scrollToSection } from "../lib/scroll";

const LINKS = [
    { id: "services", label: "Services" },
    { id: "system", label: "360° System" },
    { id: "why", label: "Why 24queue" },
    { id: "results", label: "Results" },
];

export const Footer = () => (
    <footer data-testid="footer" className="border-t-2 border-ink/10 py-10">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-5 md:flex-row md:items-center lg:px-8">
            <Logo />
            <nav className="flex flex-wrap items-center gap-6">
                {LINKS.map((l) => (
                    <button
                        key={l.id}
                        data-testid={`footer-link-${l.id}`}
                        onClick={() => scrollToSection(l.id)}
                        className="font-mono text-xs uppercase tracking-[0.18em] text-ink/60 transition-colors duration-300 hover:text-inkblue"
                    >
                        {l.label}
                    </button>
                ))}
            </nav>
            <div data-testid="queue-engine-status" className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-wider text-ink/70">
                <span className="pulse-dot h-2 w-2 rounded-full bg-emerald-500" />
                Queue Engine: Online
            </div>
        </div>
        <div className="mx-auto mt-8 flex max-w-6xl items-center justify-between px-5 lg:px-8">
            <span className="font-mono text-[11px] text-ink/40">© 2026 24queue. All rights reserved.</span>
            <span className="rotate-[-2deg] font-hand text-xl text-inkblue">we drive the traffic →</span>
        </div>
    </footer>
);
